export default __webpack_public_path__ + "static/media/audio_04_Gaviotas.b274558c.mp3";